import { useQuery } from "react-query";

import api from "../../../api";
import { FIVE_MINUTES } from "../../_helpers/constants";

interface ConsentForm {
  id: number;
  name: string;
  description: string;
  consent_form_slug: string;
  version: string;
}
interface GetClientMissingConsentsParams {
  clientId: number;
  includeManual?: boolean;
}

const getClientMissingConsents = async ({
  clientId,
  includeManual = false,
}: GetClientMissingConsentsParams) => {
  try {
    const includeManualQuery = includeManual ? "&include_manual=true" : "";
    const { data } = await api.get<ConsentForm[]>(
      `/api/getClientMissingConsents/?client_id=${clientId}${includeManualQuery}`,
    );
    return data;
  } catch (e) {
    throw new Error(`[getClientMissingConsents] Unable to fetch: ${e}`);
  }
};

export const useGetClientMissingConsents = ({
  clientId,
  enabled,
  includeManual = false,
}: {
  clientId: number;
  enabled: boolean;
  includeManual?: boolean;
}) => {
  return useQuery(
    ["ClientMissingConsents", clientId, includeManual],
    () => getClientMissingConsents({ clientId, includeManual }),
    {
      staleTime: FIVE_MINUTES,
      enabled: !!clientId && enabled,
    },
  );
};
